import { render, staticRenderFns } from "./auditComicRecord.vue?vue&type=template&id=67410f6d"
import script from "./auditComicRecord.vue?vue&type=script&lang=js"
export * from "./auditComicRecord.vue?vue&type=script&lang=js"
import style0 from "./auditComicRecord.vue?vue&type=style&index=0&id=67410f6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports